import { Modal as Modals } from '@/components/common/display/modal/v3';
import { useReportPageVisit } from '@/customHooks/useReportPageVisit.hook';
import { useHasMeinPlus } from '@/customHooks/useHasMeinPlus.hook';
import { useIntl } from '@/i18n';
import { TrackingEvents } from '@/tracking/trackingEvents';
import { AdacBanner } from './AdacBanner';

const { V3: Modal } = Modals;

export const BenefitOverview = () => {
  const { t } = useIntl();
  const isMeinPlus = useHasMeinPlus();
  useReportPageVisit(TrackingEvents.ADAC.OVERVIEW_VISITED, { isMeinPlus });

  return (
    <>
      <AdacBanner imageAlt={t({ id: 'benefits.adac.modal.image' })} />
      <Modal.Tabs
        aria-label={t({ id: 'modal.tabs.label' })}
        className='absolute-reference padding-horizontal-l palm-padding-horizontal-xl'
      >
        <Modal.Tab
          tabKey='overview'
          title={t({ id: 'modal.tabs.overview' })}
          className='one-whole padding horizontal-center'
          style={{ maxWidth: 610 }}
        >
          <h2 className='font-heading-xsmall-bold margin-bottom-l'>{t({ id: 'benefits.adac.modal.headline' })}</h2>
          <p className='margin-bottom-l'>{t({ id: 'benefits.adac.modal.description' })}</p>
          <Modal.Benefits
            sections={Object.fromEntries(
              Object.entries(sections).map(([section, services]) => [
                section,
                {
                  title: t({ id: `benefits.adac.modal.sections.${section}` }),
                  items: Object.fromEntries(
                    services.map((service) => [service, t({ id: `benefits.adac.modal.services.${service}` })]),
                  ),
                },
              ]),
            )}
          />
        </Modal.Tab>
      </Modal.Tabs>
    </>
  );
};

const sections = {
  coverage500: [
    'locksmith',
    'pestControl',
    'waspRemoval',
    'childAndPetCare',
    'electricalEmergency',
    'pipeCleaning',
    'heatingAndPlumbing',
    'householdHelp',
    'accommodation',
    'applianceRepair',
    'burglary',
  ],
  coverage150: ['floorRepair'],
  other: ['legalAdvice', 'tradespersonReferral', 'serviceProviderReferral'],
};
